// extracted by mini-css-extract-plugin
export default {"rdblock":"IR","container":"JR","rddesc":"KR","title":"LR","copy":"MR","image":"NR","tipview":"OR","rdtip":"PR"};
    if(module.hot) {
      // 1711717534321
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  